import firebase from "firebase/app";
import config from "../config";

const app = firebase.initializeApp(config.firebase);

export default app;
